import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Stack } from '@famly/mf_layout_stack';
import { hasValue } from '@famly/stat_ts-utils_has-value';
const position = { base: 'fixed', mobileLandscape: 'unset' };
const flexDirection = { base: 'column-reverse', mobileLandscape: 'unset' };
const width = { base: 'calc(100% - 2 * 24px)', mobileLandscape: 'unset' };
const justifyContentBase = {
    base: 'space-between',
    tabletPortrait: 'end',
};
const justifyContentSubmitDelete = {
    base: 'space-between',
    tabletPortrait: 'space-between',
};
/**
 * Do not use this component directly!
 *
 * Always use `StatForm`!
 * @see [StatForm](./stat-form.tsx)
 */
export const StatFormInternal = ({ children, type, }) => {
    // If certain conditions are not met, nulls are being passed in as children here, which need to be filtered out
    if (React.Children.toArray(children).filter(child => hasValue(child)).length > 0) {
        return (_jsx(Stack, { position: position, flexDirection: flexDirection, bottom: "24px" // this is the same as the form's padding
            , width: width, marginTop: 6, gap: 3, justifyContent: 
            /**
             * when we have type submitAndDelete
             * we need the delete and submit buttons to be apart from each other
             * instead of adding new conditionals, we can just re-use the css that matches
             * our use case from the mobile view where all buttons have equal spacing between 'em
             */
            type === 'submitAndDelete' ? justifyContentSubmitDelete : justifyContentBase, children: children }));
    }
    return null;
};
